export default __webpack_public_path__ + "static/media/gallery-wip-emitter_04.7b766746.jpg";